import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRightIcon } from "lucide-react";
import type React from "react";

interface DashboardRowProps {
	title: string;
	description: string;
	imageSrc: string;
	onClick: () => void;
	disabled?: boolean;
}

export const DashboardPicturedRow: React.FC<DashboardRowProps> = ({
	title,
	description,
	imageSrc,
	onClick,
	disabled = false,
}) => {
	const theme = useTheme();

	return (
		<Stack
			onClick={disabled ? undefined : onClick}
			sx={{
				position: "relative",
				width: "100%",
				height: 180,
				borderRadius: "12px",
				overflow: "hidden",
				opacity: disabled ? 0.4 : 1,
			}}
		>
			<Box
				component="img"
				src={imageSrc}
				sx={{
					width: "100%",
					height: "100%",
					objectFit: "cover",
				}}
			/>
			<Typography
				variant="h6"
				sx={{
					position: "absolute",
					top: theme.spacing(2),
					left: theme.spacing(2),
					color: theme.palette.darkmodeText.white,
					fontWeight: "bold",
					width: "55%",
					whiteSpace: "normal",
					wordBreak: "break-word",
					lineHeight: 1.2,
				}}
			>
				{title}
			</Typography>
			<Typography
				variant="deprecatedBody1"
				sx={{
					position: "absolute",
					bottom: theme.spacing(2),
					left: theme.spacing(2),
					color: theme.palette.darkmodeText.white,
					width: "50%",
					whiteSpace: "normal",
					wordBreak: "break-word",
					lineHeight: 1.2,
				}}
			>
				{description}
			</Typography>
			<IconButton
				sx={{
					position: "absolute",
					right: theme.spacing(2),
					top: "50%",
					transform: "translateY(-50%)",
					color: theme.palette.darkmodeText.white,
				}}
			>
				<ChevronRightIcon />
			</IconButton>
		</Stack>
	);
};
